import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ProcurementTypeAdapter } from './dto/procurement-type.adapter';
import { ProcurementTypesController } from './procurement-types.controller';
import { ProcurementType } from './procurement-types.entity';
import { ProcurementTypesService } from './procurement-types.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([ProcurementType]),
  ],
  controllers: [ProcurementTypesController],
  providers: [ProcurementTypesService,ProcurementTypeAdapter,ApplicationExceptionHandler, WhatsAppNotificationService],
})
export class ProcurementTypesModule {}
